
(function () {
  'use strict';

  function initLuxuryProductHero(root) {
    const galleries = root.querySelectorAll(
      '[data-luxury-gallery]'
    );

    galleries.forEach((gallery) => {
      if (gallery.dataset.sliderInitialized === 'true') {
        return;
      }

      gallery.dataset.sliderInitialized = 'true';

      const mainImage = gallery.querySelector(
        '.luxury-main-image'
      );

      const thumbnails = Array.from(
        gallery.querySelectorAll('.luxury-thumbnail-item')
      );

      const prevBtn = gallery.querySelector(
        '[data-gallery-prev]'
      );

      const nextBtn = gallery.querySelector(
        '[data-gallery-next]'
      );

      if (!mainImage || thumbnails.length === 0) {
        return;
      }

      let currentIndex = thumbnails.findIndex(
        (thumb) => thumb.classList.contains('active')
      );

      if (currentIndex < 0) {
        currentIndex = 0;
      }

      const interval = Math.max(
        1000,
        parseInt(gallery.dataset.autoplay, 10) || 4000
      );

      const reducedMotion = window.matchMedia(
        '(prefers-reduced-motion: reduce)'
      );

      let autoplayTimer = null;
      let transitionTimer = null;
      let imageRequest = 0;
      let isHovered = false;
      let isFocused = false;
      let isVisible = true;
      let touchStartX = 0;
      let touchStartY = 0;

      function updateThumbnails() {
        thumbnails.forEach((thumb, index) => {
          const isActive = index === currentIndex;

          thumb.classList.toggle('active', isActive);

          thumb.setAttribute(
            'aria-pressed',
            String(isActive)
          );
        });

        const activeThumb = thumbnails[currentIndex];

        if (activeThumb) {
          activeThumb.scrollIntoView({
            behavior: reducedMotion.matches
              ? 'instant'
              : 'smooth',
            block: 'nearest',
            inline: 'nearest'
          });
        }
      }

      function showSlide(index) {
        if (thumbnails.length === 0) return;

        const nextIndex =
          (index + thumbnails.length) % thumbnails.length;

        if (nextIndex === currentIndex) return;

        currentIndex = nextIndex;

        const activeThumb = thumbnails[currentIndex];

        const imageUrl = activeThumb.dataset.image;
        const imageAlt = activeThumb.dataset.alt || '';

        updateThumbnails();

        if (!imageUrl) return;

        const requestId = ++imageRequest;

        clearTimeout(transitionTimer);

        const preloadedImage = new Image();

        preloadedImage.onload = function () {
          if (requestId !== imageRequest) return;

          if (reducedMotion.matches) {
            mainImage.src = imageUrl;
            mainImage.alt = imageAlt;
            return;
          }

          mainImage.classList.add('is-changing');

          transitionTimer = setTimeout(() => {
            if (requestId !== imageRequest) return;

            mainImage.src = imageUrl;
            mainImage.alt = imageAlt;

            requestAnimationFrame(() => {
              mainImage.classList.remove('is-changing');
            });
          }, 180);
        };

        preloadedImage.onerror = function () {
          if (requestId !== imageRequest) return;

          mainImage.classList.remove('is-changing');
        };

        preloadedImage.src = imageUrl;
      }

      function nextSlide() {
        showSlide(currentIndex + 1);
      }

      function previousSlide() {
        showSlide(currentIndex - 1);
      }

      function stopAutoplay() {
        if (autoplayTimer !== null) {
          clearInterval(autoplayTimer);
          autoplayTimer = null;
        }
      }

      function startAutoplay() {
        stopAutoplay();

        if (
          thumbnails.length <= 1 ||
          reducedMotion.matches ||
          document.hidden ||
          isHovered ||
          isFocused ||
          !isVisible
        ) {
          return;
        }

        autoplayTimer = setInterval(() => {
          nextSlide();
        }, interval);
      }

      function resetAutoplay() {
        stopAutoplay();
        startAutoplay();
      }

      thumbnails.forEach((thumb, index) => {
        thumb.addEventListener('click', () => {
          showSlide(index);
          resetAutoplay();
        });
      });

      if (prevBtn) {
        prevBtn.addEventListener('click', () => {
          previousSlide();
          resetAutoplay();
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', () => {
          nextSlide();
          resetAutoplay();
        });
      }

      gallery.addEventListener('mouseenter', () => {
        isHovered = true;
        stopAutoplay();
      });

      gallery.addEventListener('mouseleave', () => {
        isHovered = false;
        startAutoplay();
      });

      gallery.addEventListener('focusin', () => {
        isFocused = true;
        stopAutoplay();
      });

      gallery.addEventListener('focusout', (event) => {
        if (!gallery.contains(event.relatedTarget)) {
          isFocused = false;
          startAutoplay();
        }
      });

      gallery.addEventListener(
        'touchstart',
        (event) => {
          if (event.touches.length !== 1) return;

          touchStartX = event.touches[0].clientX;
          touchStartY = event.touches[0].clientY;
        },
        { passive: true }
      );

      gallery.addEventListener(
        'touchend',
        (event) => {
          if (event.changedTouches.length !== 1) return;

          const touchEndX =
            event.changedTouches[0].clientX;

          const touchEndY =
            event.changedTouches[0].clientY;

          const diffX = touchStartX - touchEndX;
          const diffY = touchStartY - touchEndY;

          // Ignore vertical scrolling and small movements
          if (
            Math.abs(diffX) < 50 ||
            Math.abs(diffX) <= Math.abs(diffY)
          ) {
            return;
          }

          if (diffX > 0) {
            nextSlide();
          } else {
            previousSlide();
          }

          resetAutoplay();
        },
        { passive: true }
      );

      gallery.addEventListener('keydown', (event) => {
        if (
          !event.target.closest(
            '.luxury-main-image-wrapper'
          )
        ) {
          return;
        }

        if (event.key === 'ArrowRight') {
          event.preventDefault();
          nextSlide();
          resetAutoplay();
        }

        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          previousSlide();
          resetAutoplay();
        }
      });

      document.addEventListener(
        'visibilitychange',
        startAutoplay
      );

      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              isVisible = entry.isIntersecting;

              if (isVisible) {
                startAutoplay();
              } else {
                stopAutoplay();
              }
            });
          },
          { threshold: 0.1 }
        );

        observer.observe(gallery);
      }

      const onMotionChange = () => {
        if (reducedMotion.matches) {
          mainImage.classList.remove('is-changing');
        }

        startAutoplay();
      };

      if (reducedMotion.addEventListener) {
        reducedMotion.addEventListener(
          'change',
          onMotionChange
        );
      }

      updateThumbnails();
      startAutoplay();
    });

    // EXISTING QUANTITY FUNCTIONALITY
    const sections = root.querySelectorAll(
      '.luxury-product-hero'
    );

    sections.forEach((section) => {
      const qtyInput = section.querySelector(
        '.luxury-qty-input'
      );

      const plusBtn = section.querySelector('.qty-plus');
      const minusBtn = section.querySelector('.qty-minus');

      if (!qtyInput || !plusBtn || !minusBtn) {
        return;
      }

      if (qtyInput.dataset.qtyInitialized === 'true') {
        return;
      }

      qtyInput.dataset.qtyInitialized = 'true';

      plusBtn.addEventListener('click', () => {
        const current = parseInt(qtyInput.value, 10) || 1;

        qtyInput.value = current + 1;

        qtyInput.dispatchEvent(
          new Event('change', { bubbles: true })
        );
      });

      minusBtn.addEventListener('click', () => {
        const current = parseInt(qtyInput.value, 10) || 1;

        qtyInput.value = Math.max(1, current - 1);

        qtyInput.dispatchEvent(
          new Event('change', { bubbles: true })
        );
      });
    });
  }

  function initialize() {
    initLuxuryProductHero(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initialize
    );
  } else {
    initialize();
  }

  // Shopify theme editor section reload support
  document.addEventListener(
    'shopify:section:load',
    (event) => {
      initLuxuryProductHero(event.target);
    }
  );
})();
